import React from 'react'

const Story = () => {
    return (
        <div>
            <>

                <section className="trusted-story">
                    
                    <div className="container p-0">
                        <div class="cta-sec cta-coral">
                            <h2 class="disp-md">Find who you're meant for. In weeks, not years.</h2>
                            <p>Join 2,400+ early members on the waitlist. DNA kit ships Q3 2026.</p>
                            <div class="cta-btns">
                                <button class="btn btn-white">How the Science Works <span class="arr">→</span></button>
                                <button class="btn investerbtn" >Investor Overview</button>
                            </div>
                        </div>
                    </div>
                </section>
            </>

        </div>
    )
}

export default Story
